<script lang="ts">
    import BackgroundOverlay from './background/background-overlay.svelte';
    import { fade } from 'svelte/transition';
    import dayjs from 'dayjs';
    import Duration from 'dayjs/plugin/duration';

    import slide1 from '@src/assets/img/welcome_screen_slide_1.webp';
    import slide2 from '@src/assets/img/welcome_screen_slide_2.webp';
    import slide3 from '@src/assets/img/welcome_screen_slide_3.webp';

    import WelcomeScreenFooter from './welcome-screen/welcome-screen-footer.svelte';
    import WelcomeScreenSlider from './welcome-screen/welcome-screen-slider.svelte';
    import { afterUpdate, createEventDispatcher, onMount } from 'svelte';
    import { trackEvent } from '@root/src/utils/init-analytics';

    dayjs.extend(Duration);
    const dispatch = createEventDispatcher();

    export let skipAgain = true;
    export let soundEnabled: boolean;

    let durationInWelcomeScreen = null;
    let durationTotal = null;
    let countSlideChanges = 0;
    let currentSlideIndex = 0;

    const slidesInfo = [
        {
            img_slide: slide1,
            title_slide: 'How to Play',
            desc_slide:
                'Place your bets on the Crazy Crazy Claw layout that displays eight available betting positions corresponding to the balls in Claw Machine'
        },
        {
            img_slide: slide2,
            title_slide: 'Bonus Reels',
            desc_slide:
                'Two reels are placed at the top of the screen, one of them chooses the multiplier which will be applied to the win of the feature picked by the second reel'
        },
        {
            img_slide: slide3,
            title_slide: 'Four Bonus Games',
            desc_slide: 'Pull out the corresponding ball to test your luck in your bonus rounds.'
        }
    ];

    onMount(() => {
        durationInWelcomeScreen = dayjs();
    });
    afterUpdate(() => {
        durationTotal = dayjs.duration(dayjs().diff(durationInWelcomeScreen)).asSeconds();
    });

    const closeHandler = () => {
        trackEvent('welcome_page_quit', {
            welcome_waiting_time: durationTotal,
            pages_swiched_count: countSlideChanges,
            welcome_page_number: currentSlideIndex
        });
        dispatch('close');
    };
</script>

<!-- @TODO match the design and refactor -->
<div class="welcome-screen-root z-[9011]" out:fade|global>
    <BackgroundOverlay />
    <div
        class="fixed inset-0 mx-auto my-0 flex h-full w-full flex-col flex-nowrap gap-4 overflow-y-auto px-2 pb-6 font-Roboto tablet:!max-w-3xl tablet:justify-center tablet:overflow-y-hidden"
    >
        <!-- <WelcomeScreenVertical {slidesInfo} /> -->
        <WelcomeScreenSlider
            {slidesInfo}
            on:slide-change={data => (countSlideChanges += data.detail)}
            on:current-slide-index={data => (currentSlideIndex = data.detail)}
        />
        <WelcomeScreenFooter {skipAgain} {soundEnabled} on:skip-again on:toogle-mute on:close={closeHandler} />
    </div>
</div>

<style>
    .welcome-screen-root {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>
